module.exports = __webpack_public_path__ + "img/buessiness_ky_c.16f9e71b.png";